import React from 'react'; 
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

const useStyles = (theme?: any) => ({
  widgetwrapper: {
    borderRadius: '8px !important',
    backgroundColor: `${theme.palette.background.shadedown_10} !important`,
    padding: '8px !important',
    marginBottom: '8px !important',
  },
});

const WidgetWrapper = ({ children }: { children: any }) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return <Box sx={classes.widgetwrapper}>{children}</Box>;
};

export default React.memo(WidgetWrapper);
